// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1425 ? "2170a4aa" : chunkId) + "." + {"1425":"cc9ad3fcff27c821","6919":"aa06879c0773525b"}[chunkId] + ".js";
};